import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getMovimentoContato from "../queries/getMovimentoContato";


export function useGetMovimentoContato(ContatoId: number) {
  const resultQuery = useQuery(
    [`${URLS.CONTATO_MOVIMENTO_API}`, {
      params: {ContatoId}
    }], 
    () => getMovimentoContato(ContatoId));

  return resultQuery;
}
